export default "__VITE_ASSET__Q6ifTgSR__"